import { Subject, Observable } from 'rxjs';

import { SgAsyncGuiPlugins, SgAsyncGuiPluginContext, SgAsyncGuiPhase, SgAsyncGuiEvent } from './types';

export class SgAsyncGuiRef<T = any, D = any> {
  public style: keyof SgAsyncGuiPlugins;
  public data?: D;
  readonly closed: Observable<T>;
  private _close: Subject<T>;

  private constructor(public readonly events: Observable<SgAsyncGuiEvent | SgAsyncGuiPhase>) {
    this._close = new Subject<T>();
    this.closed = this._close.asObservable();
  }

  close(value?: T): void {
    if (this._close.closed) {
      throw new Error('Already closed');
    } else {
      this._close.next(value);
      this._close.complete();
    }
  }

  static create<T = any, D = any>(
    style: keyof SgAsyncGuiPlugins,
    ctx: SgAsyncGuiPluginContext,
    events: Observable<SgAsyncGuiEvent | SgAsyncGuiPhase>
  ): SgAsyncGuiRef<T, D> {
    const ref = new SgAsyncGuiRef<T, D>(events);
    ref.style = style;
    ref.data = ctx.options.data;
    return ref;
  }
}
